import React from 'react'
import { Container, Typography, Stack, Paper, useTheme } from '@mui/material'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'

export const PrivacyPolicyPage = () => {
  const theme = useTheme()

  return (
    <Stack minHeight="100vh" sx={{ display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Container maxWidth="md" sx={{ flex: 1, py: 4 }}>
        <Paper elevation={3} sx={{ p: 4, backgroundColor: theme.palette.background.paper }}>
          <Typography variant="h3" sx={{ mb: 3, fontWeight: 'bold', color: theme.palette.primary.main }}>
            Privacy Policy
          </Typography>

          <Stack spacing={3}>
            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                1. Information We Collect
              </Typography>
              <Typography>
                We collect information you provide directly, including name, email, phone number, address, and payment information. We also automatically collect certain information like IP address, browser type, and browsing patterns through cookies.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                2. How We Use Your Information
              </Typography>
              <Typography>
                Your information is used to process orders, send order updates, provide customer support, improve our services, and with your consent, send promotional emails. We never sell your data to third parties.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                3. Data Security
              </Typography>
              <Typography>
                We implement industry-standard security measures including encryption and secure payment gateways to protect your personal information from unauthorized access.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                4. Your Rights
              </Typography>
              <Typography>
                You have the right to access, update, or delete your personal information at any time. Contact us at sardarlaeiq786@gmail.com to exercise these rights.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                5. Cookies
              </Typography>
              <Typography>
                We use cookies to enhance your browsing experience. You can control cookie settings through your browser preferences.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                6. Contact Us
              </Typography>
              <Typography>
                For privacy concerns, email us at sardarlaeiq786@gmail.com or WhatsApp: +923448252109
              </Typography>
            </Paper>

            <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary' }}>
              Last Updated: {new Date().toLocaleDateString()}
            </Typography>
          </Stack>
        </Paper>
      </Container>
      <Footer />
    </Stack>
  )
}
